module.exports = __webpack_public_path__ + "static/media/playbutton@2x.c8dea102.png";